module.exports = __webpack_public_path__ + "static/media/kehuxinxi61.29e3084f.png";